/*  MUI  */
import { Theme } from '@mui/material/styles';

export const getScoreBorderColor = ({
    value,
    theme
}: {
    value: number;
    theme: Theme;
}) => {
    if (typeof value !== 'number') {
        return theme.palette.saasScore.borderColor.none;
    }
    if (value < 40) {
        return theme.palette.saasScore.borderColor.low;
    }
    if (value < 70) {
        return theme.palette.saasScore.borderColor.medium;
    }
    return theme.palette.saasScore.borderColor.excellent;
};
